import { FC } from "react";
import styled from "styled-components";

interface ParagraphProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

interface BoldProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

const StyledSpan = styled.span`
  font-size: 1em;
  color: ${({ theme }) => theme.text}; 
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
`;

const StyledBold = styled.b`
  font-size: 1.1em;
  color: ${({ theme }) => theme.text};
  display: inline;
`;

const Span: React.FC<ParagraphProps> & {
  Bold: React.FC<BoldProps>;
} = ({ children, ...props }) => {
  return <StyledSpan {...props}>{children}</StyledSpan>;
};

Span.Bold = ({ children, ...props }: BoldProps) => (
  <StyledBold {...props}>{children}</StyledBold>
);

export default Span;
